import React from 'react';

import {StepAttachmentsTitle} from 'app/procedures/components/structures';

import type {AttachedFileType} from 'app/general/types';
type Props = {
  files: Array<AttachedFileType>;
  onRemove: (index: number) => void;
};

export const EditableProcedureStepFiles = ({files, onRemove}: Props) =>
  files.length > 0 ? (
    <div className="mb-4">
      <StepAttachmentsTitle className="mt-3" />
      <div className="small">
        <ul>
          {files.map((file, index) => (
            <li key={file.file_ref}>
              <span className="mr-2">{file.file_name}</span>
              <span className="mr-2"> ( {file.file_type} )</span>
              <button
                className="btn btn-link btn-sm"
                onClick={() => onRemove(index)}
              >
                <i className="fa fa-times" />
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  ) : null;
